import { Plugin } from "ckeditor5";
import { ButtonView } from "ckeditor5";

export class Timestamp extends Plugin {
  init() {
    const editor = this.editor;
    editor.ui.componentFactory.add("timestamp", () => {
      const button = new ButtonView();

      button.set({
        label: "Timestamp",
        withText: true,
      });
      button.on("execute", () => {
        const now = new Date();

        editor.model.change((writer) => {
          editor.model.insertContent(writer.createText(now.toString()));
        });
      });

      return button;
    });
  }
}
